const TopPerformingContent = () => {
  const data = [
    {
      title: "Most Clicked Link",
      content: "Shop the New Winter Collection",
      sub: "(1,204 clicks)",
    },
    {
      title: "Best Subject Line",
      content: "You won't believe this week's deal!",
      sub: "(31.5% OR)",
    },
    {
      title: "Best Subject Line",
      content: "You won't believe this week's deal!You won't believe this week's deal!",
      sub: "(31.5% OR)",
    },
    {
      title: "Best Subject Line",
      content: "You won't believe this week's deal! You won't believe this week's deal!",
      sub: "(31.5% OR)",
    },
    {
      title: "Best Subject Line",
      content: "You won't believe this week's deal!",
      sub: "(31.5% OR)",
    },
 
  ];

  return (
    <div
      className="
        w-full h-[400px]
        p-3
        rounded-xl
        bg-white dark:bg-slate-800
        shadow
        border border-transparent dark:border-slate-700
        flex flex-col
      "
    >
      {/* Header */}
      <div className="flex-shrink-0 text-base font-medium text-slate-800 dark:text-slate-200">
        Top Performing Content
      </div>

      {/* CONTENT BOX WITH SCROLL */}
      <div className="mt-4 flex flex-col gap-4 overflow-auto flex-1">
        {data.map((item, idx) => (
          <div key={idx} className="flex items-start gap-3">
            {/* Blue dot */}
            <div
              className="
                w-[10px] h-[10px]
                rounded-full
                bg-[#2F6FE4]
                mt-[6px]
                shrink-0
              "
            />

            {/* Text Content */}
            <div className="break-words">
              <div className="text-sm text-slate-800 dark:text-slate-200">
                <span className="font-medium">
                  {item.title}:
                </span>{" "}
                <span>"{item.content}"</span>
              </div>

              <div className="mt-1 text-sm text-slate-500 dark:text-slate-400">
                {item.sub}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopPerformingContent;